const shareNetwork = {
	"index-view": {
		title: "Nodig je netwerk uit",
		tutorial: {
			title: "Hoe werkt het referral programma",
		},
		heading: {
			title: "Meld bedrijven aan en verdien tot € 50 per bedrijf",
			description:
				"Wanneer een bedrijf zich aanmeldt krijg je € 25. Plaatst het bedrijf daarna een opdracht boven de € 150? Dan voegen we nog eens € 25 toe.",
		},
	},
};
export default shareNetwork;
